module.exports = __webpack_public_path__ + "static/4-a170a251274a0bd8ef412535cd5284ad.png";